<Loader :loading="loading" />
<HomeNavBar />

<div class="row">
  <!-- Sidebar -->
  <div class="col-lg-2 d-lg-block h-100">
    <MenuSideBar />
  </div>

  <!-- Main Content -->
  <div class="col-lg-10 p-2 scroll-container">
    <!-- Tabs Header -->
    <div class="text-center">
      <h2 class="fw-bold text-uppercase mt-2">
        <span class="fw-bolder" v-if="activeTab === 'assets'">Assets</span>
        <span class="fw-bolder" v-if="activeTab === 'bookings'">Bookings</span>
      </h2>
    </div>
        <!-- Tabs Navigation -->
        <div class="bg-light shadow-sm banner-pills">
          <div class="d-flex justify-content-center bg-banner-gradient p-2">
            <ul class="pills-billing-tab nav nav-pills mx-auto" role="tablist">
              <li class="nav-item text-center" role="presentation">
                <button
                  class="nav-link w-100 text-xs fw-500"
                  :class="{ active: activeTab === 'assets' }"
                  @click="activeTab = 'assets'"
                >
                  Assets
                </button>
              </li>
              <li class="nav-item text-center" role="presentation">
                <button
                  class="nav-link w-100 text-xs fw-500"
                  :class="{ active: activeTab === 'bookings' }"
                  @click="show_my_bookings"
                >
                  My Bookings
                </button>
              </li>
            </ul>
          </div>
        </div>
    <!-- Assets Tab -->
    <div v-if="activeTab === 'assets'">
      <div class="">
        <button
          class="fab border-0 shadow mx-5 mt-4"
          data-bs-toggle="modal"
          data-bs-target="#create_community_asset_modal"
        >
          +
        </button>
      </div>

      <div class="event-group mx-5">
        <div class="d-flex align-items-center temporary-post" v-if="temporary_asset_post" id="temp-post">
          <p class="text-xs fw-bold">Editing...</p>
          <div class="spinner-border ms-auto text-secondary" role="status" aria-hidden="true"></div>
        </div>

        <div v-for="community_asset in community_assets" :key="community_asset?.id"
          class="card event-card lh-sm mt-2 border-0 border-bottom-primary position-relative">

          <div class="event-arrow"></div>
          <div class="card-body">
            <!-- Dots dropdown -->
            <div class="dropend float-end" @click.stop>
              <a href="" class="fw-bold text-dark" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="bi bi-three-dots-vertical"></i>
              </a>
              <ul class="dropdown-menu custom-dropdown lh-1" aria-labelledby="dropdownMenuButton">
                <li v-if="current_role === 'admin' || community_asset.creater?.id === current_user_id">
                  <a class="dropdown-item text-xs fw-bold" href="#"
                     @click.prevent="view_bookings(community_asset)"
                     data-bs-toggle="modal" data-bs-target="#bookingsListModal">
                    <i class="bx bx-calendar fs-6"></i> View Bookings
                  </a>
                </li>
                <li v-if="community_asset.creater?.id === current_user_id && !community_asset.is_booked">
                  <a class="dropdown-item text-xs fw-bold" href="" @click.prevent="edit_asset(community_asset)">
                    <i class="bx bxs-edit fs-6"></i> Edit
                  </a>
                </li>
                <li v-if="current_role === 'admin' || community_asset.creater?.id === current_user_id">
                  <a class="dropdown-item text-xs fw-bold" href="" @click.prevent="delete_asset(community_asset.id)">
                    <i class="bx bxs-trash-alt fs-6"></i> Delete
                  </a>
                </li>
                <li v-else>
                  <a class="dropdown-item text-xs fw-bold text-danger" href="#" @click.prevent="not_allowed_alert()">
                    <i class="bi bi-exclamation-triangle"></i> Not allowed
                  </a>
                </li>
              </ul>
            </div>

            <!-- Asset info -->
            <p class="card-title fw-bold">{{ community_asset.name }}</p>
            <p class="text-muted text-xs">
              <i class="bi bi-geo-alt text-danger"></i> {{ community_asset.location }}
            </p>
            <span
              @click.stop="select_asset(community_asset)"
              data-bs-toggle="modal"
              data-bs-target="#assetModal"
              class="btn btn-primary rounded-5 text-xs mt-0 me-2"
            >
              See more
            </span>
          </div>
        </div>
      </div>
  </div>
          <!-- My Bookings Tab -->
          <div v-if="activeTab === 'bookings'" class="mx-4 mt-3">
            <!-- Empty State -->
            <div v-if="my_bookings.length === 0" class="text-center py-5">
              <div class="mb-4">
                <i class="bi bi-calendar-x text-muted"></i>
              </div>
              <h5 class="text-muted mb-3">No Bookings Yet</h5>
              <p class="text-muted">You haven't made any bookings yet. Start exploring our assets!</p>
            </div>
          
            <!-- Bookings List -->
            <div v-else>
              <div class="d-flex justify-content-between align-items-center mb-4">
                <h4 class="mb-0">My Bookings</h4>
                <span class="badge bg-light text-dark">{{ my_bookings.length }} booking{{ my_bookings.length !== 1 ? 's' : '' }}</span>
              </div>
          
              <div class="row g-3">
                <div v-for="booking in my_bookings" :key="booking?.id" class="col-12">
                  <div class="card shadow-sm border-0 h-100">
                    <div class="card-body">
                      <div class="row align-items-center">
                        <!-- Asset Info -->
                        <div class="col-md-4 mb-3 mb-md-0">
                          <div class="d-flex align-items-center">
      
                            <div>
                              <h6 class="mb-1 fw-bold">{{ booking.asset }}</h6>
                              <small class="text-muted">Booking</small>
                            </div>
                          </div>
                        </div>
      
                        <!-- Date & Time Info -->
                        <div class="col-md-4 mb-3 mb-md-0">
                          <div class="text-center text-md-start">
                            <div class="mb-2">
                              <i class="bi bi-calendar3 text-muted me-2"></i>
                              <span class="fw-medium">{{ booking.booking_start_date }}</span>
                            </div>
                            <div>
                              <i class="bi bi-clock text-muted me-2"></i>
                              <span class="text-muted small">
                                {{ formatTime(booking.booking_start_time) }} - {{ formatTime(booking.booking_end_time) }}
                              </span>
                            </div>
                          </div>
                        </div>
      
                        <!-- Status & Actions -->
                      <div class="col-md-4 text-center text-md-end">
                        <div class="d-flex justify-content-center justify-content-md-end align-items-center gap-2 mb-3">
                          <span 
                          class="badge px-3 py-2"
                          :class="{
                            'bg-primary': booking.status.toLowerCase() === 'booked',
                            'bg-success': booking.status.toLowerCase() === 'completed',
                            'bg-warning': ['in progress', 'pending'].includes(booking.status.toLowerCase()),
                            'bg-danger': ['cancelled', 'rejected'].includes(booking.status.toLowerCase()),
                          }"
                        >
                          <i 
                            class="bi me-1"
                            :class="{
                              'bi-bookmark-check': booking.status.toLowerCase() === 'booked',
                              'bi-check-circle': booking.status.toLowerCase() === 'completed',
                              'bi-hourglass-split': ['in progress', 'pending'].includes(booking.status.toLowerCase()),
                              'bi-x-circle': ['cancelled', 'rejected'].includes(booking.status.toLowerCase())
                            }"
                          ></i>
                          {{ booking.status.charAt(0).toUpperCase() + booking.status.slice(1) }}
                        </span>
      
                          <button
                            v-if="booking.status === 'booked'"
                            class="btn btn-outline-danger btn-sm"
                            @click="cancel_booking(booking.id)"
                          >
                            <i class="bi bi-x-circle me-1"></i>
                            Cancel
                          </button>
                        </div>
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


<!-- Create Community Asset Modal -->
<div
  class="modal fade"
  id="create_community_asset_modal"
  tabindex="-1"
  aria-labelledby="createCommunityAssetLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-light">
        <h6 class="modal-title fw-bold" id="createCommunityAssetLabel">
          Create Community Asset
        </h6>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <form @submit.prevent="createcommunity_asset">
        <div class="modal-body">
          <div class="mb-3">
            <label for="asset_name" class="form-label text-xs fw-500">Asset Name<span class="text-danger">*</span></label>
            <input
              type="text"
              id="asset_name"
              class="form-control rounded-5 text-xs"
              v-model="asset_name"
              required
            />
            <div v-if="errors.community_asset_name" class="text-danger text-xs mt-1">
              {{ errors.community_asset_name }}
            </div>
          </div>

          <div class="mb-3">
            <label for="description" class="form-label text-xs fw-500">Description</label>
            <textarea
              id="description"
              class="form-control rounded-5 text-xs"
              rows="3"
              v-model="description"
            ></textarea>
          </div>

          <div class="mb-3">
            <label for="location" class="form-label text-xs fw-500">Location<span class="text-danger">*</span></label>
            <input
              type="text"
              id="location"
              class="form-control rounded-5 text-xs"
              v-model="location"
              required
            />
          </div>

          <div class="mb-3">
            <label for="category_id" class="form-label text-xs fw-500">Category<span class="text-danger">*</span></label>
            <select
              id="category_id"
              class="form-select rounded-5 text-xs"
              v-model="category_id"
              required
            >
              <option value="" disabled>Select a category</option>
              <option
                v-for="category in community_asset_categories"
                :key="category.id"
                :value="category.id"
              >
                {{ category.name }}
              </option>
            </select>
          </div>

          <div class="mb-3">
            <label for="file" class="form-label text-xs fw-500">Upload Media<span class="text-danger">*</span></label>
            <input
              type="file"
              id="file"
              class="form-control"
              @change="upload_media = $event.target.files[0]"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="submit"
            class="btn btn-primary rounded-5"
            :disabled="isSubmitting"
          >
            {{ isSubmitting ? 'Creating...' : 'Save Asset' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>


<div class="modal fade" id="assetModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content rounded">
      <div class="modal-header bg-light">
        <h6 class="modal-title fw-bold">{{ selected_asset.name }}</h6>
        <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body modal-body-scroll">
        <div>
          <p><strong>Description:</strong> <span v-html="selected_asset.description"></span></p>
        </div>
        <p><strong>Location:</strong> {{ selected_asset.location }}</p>

        <div v-if="selected_asset.community_asset_files && selected_asset.community_asset_files.length" class="d-flex flex-column align-items-start position-relative">
          <img v-if="selected_asset.community_asset_files[0].file.file_url.includes('.jpg') || 
                     selected_asset.community_asset_files[0].file.file_url.includes('.png') || 
                     selected_asset.community_asset_files[0].file.file_url.includes('.jpeg')"
               :src="selected_asset.community_asset_files[0].file.file_url"
               alt="Community Asset Image"
               class="img-fluid rounded-5 my-3 w-25"
               :class="{ 'zoomed-in': isZoomed }"
               ref="image" />
        </div>

        <!-- My Bookings for this asset -->
        <div v-if="booked_slots.filter(b => b.status.toLowerCase() === 'booked').length > 0">
          <h6 class="fw-bold mt-4">Your bookings:</h6>
          <div class="row g-3">
            <div v-for="booking in booked_slots.filter(b => b.status.toLowerCase() === 'booked')" :key="booking.id" class="col-12">
              <div class="card shadow-sm border-0 h-100">
                <div class="card-body">
                  <div class="row align-items-center">
                    <!-- Date & Time Info -->
                    <div class="col-md-6 mb-3 mb-md-0">
                      <div class="text-center text-md-start">
                        <div class="mb-2">
                          <i class="bi bi-calendar3 text-muted me-2"></i>
                          <span class="fw-medium">{{ booking.booking_start_date }}</span>
                        </div>
                        <div>
                          <i class="bi bi-clock text-muted me-2"></i>
                          <span class="text-muted small">
                            {{ formatTime(booking.booking_start_time) }} - {{ formatTime(booking.booking_end_time) }}
                          </span>
                        </div>
                      </div>
                    </div>

                    <!-- Status & Actions -->
                    <div class="col-md-6 text-center text-md-end">
                      <div class="d-flex justify-content-center justify-content-md-end align-items-center gap-2 mb-3">
                        <span
                          class="badge px-3 py-2"
                          :class="{
                            'bg-primary': booking.status.toLowerCase() === 'booked',
                            'bg-success': booking.status.toLowerCase() === 'completed',
                            'bg-warning': ['in progress', 'pending'].includes(booking.status.toLowerCase()),
                            'bg-danger': ['cancelled', 'rejected'].includes(booking.status.toLowerCase()),
                          }"
                        >
                          {{ booking.status.charAt(0).toUpperCase() + booking.status.slice(1) }}
                        </span>

                        <button
                          v-if="booking.status === 'booked'"
                          class="btn btn-outline-danger btn-sm"
                          @click="cancel_booking(booking.id)"
                        >
                          <i class="bi bi-x-circle me-1"></i>
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- No bookings fallback -->
        <div v-else>
          <p>No bookings yet.</p>
        </div>
      </div>

      <div class="modal-footer justify-content-end">
        <button class="d-none btn btn-warning btn-lg text-white text-xs rounded-5 shadow-lg fw-500"
          v-if="!selected_asset.subscribed" :id="'subscribe-button-' + selected_asset.id"
          @click="subscribeCommunityAsset(selected_asset)">Subscribe</button>
        <button class="btn btn-warning btn-lg text-white text-xs rounded-5 shadow-lg fw-500"
          v-if="selected_asset.subscribed" :id="'subscribed-button-' + selected_asset.id"
          @click="unsubscribeCommunityAsset(selected_asset)">Unsubscribe</button>
        <button class="btn btn-primary text-white text-xs rounded-5 shadow-lg fw-500"
          @click="openBookingModal(selected_asset)">
          Book Now
        </button>
      </div>
    </div>
  </div>
</div>




<div class="offcanvas offcanvas-start" tabindex="-1" id="community_assets" aria-labelledby="community_assets_label">
  <div class="offcanvas-header">
    <h5 class="offcanvas-title" id="community_assets_label">Community Assets</h5>
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">
    <table v-if="community_assets" class="table mb-0">
      <tbody>
        <tr v-for="community_asset in community_assets" :key="community_asset.id" class="hover-row border-0 ">
          <td class="border-0">
            <span class="text-decoration-none text-dark"  @click="display_community_asset(community_asset)">
              <p class="portal-icon mb-0 d-flex align-items-center">
                <a class="rounded-circle bg-yellow p-1 shadow-sm text-change"><i class='bx bx-command fs-5'></i></a>
                <span class="text-xs fw-500 mx-2">{{ community_asset.name }}</span>
              </p>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>


<!-- <FloatingButtonComponent  /> -->

<div class="modal fade" id="edit_asset"  tabindex="-1" aria-labelledby="editAssetModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-light">
        <p class="modal-title fw-bold" id="editAssetModalLabel">Edit Community Asset</p>
        <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <form @submit.prevent="updateCommunityAsset">
        <div class="modal-body">
          <div class="mb-3">
            <label for="edit_asset_name" class="form-label text-xs fw-500">Community Asset Name <span class="text-danger">*</span></label>
            <input type="text" class="form-control rounded-5 text-xs" id="edit_asset_name" v-model="edit_asset_name" required>
          </div>
          <div class="mb-3">
            <label for="edit_location" class="form-label text-xs fw-500">Community Asset Location <span class="text-danger">*</span></label>
            <input type="text" class="form-control rounded-5 text-xs" id="edit_location" v-model="edit_asset_location" required>
          </div>

          <div class="mb-3">
            <label for="category_id" class="form-label text-xs fw-500">Select a Category<span class="text-danger">*</span></label>
            <select class="form-select rounded-5 text-xs" id="category_id" v-model="edit_asset_category">
              <option selected hidden>Select a Category</option>
              <option v-for="category in community_asset_categories" :value="category.id" :key="category.id">{{ category.name }}</option>
            </select>
          </div>

          <div class="mb-3">
            <QuillEditor theme="snow" v-model="edit_description" ref="quillEventEditorRef" class="quill-editor"
              placeholder="Enter your description here..." toolbar="full" />
          </div>

          <div v-if="selected_asset.community_asset_files && selected_asset.community_asset_files.length" class="d-flex flex-column align-items-center position-relative">
            <!-- Image Container with position relative -->
            <img v-if="selected_asset.community_asset_files[0].file.file_url.includes('.jpg') || 
                       selected_asset.community_asset_files[0].file.file_url.includes('.png') || 
                       selected_asset.community_asset_files[0].file.file_url.includes('.jpeg')"
                 :src="selected_asset.community_asset_files[0].file.file_url"
                 alt="Community Asset Image"
                 class="img-fluid rounded-5 my-3 w-55"
                 :class="{ 'zoomed-in': isZoomed }"
                 ref="image" />
          </div>
          <div class="file-upload my-2 me-4 flex-grow-1 d-flex flex-column align-items-center">
            <label @click="triggerFileInput" class="text-xs text-secondary fw-500 border-0 rounded-5 btn-sm mb-3 bg-light d-flex align-items-center justify-content-center">
              <i class='bx bx-image-add file-upload-icon'></i> Add Asset content
            </label>

            <input type="file" id="fileInput" ref="fileInput" class="d-none" @change="handleAssetFileUpload" />

            <div v-if="asset_file_name" class="text-xs text-secondary fst-italic mt-1">
              <span class="fw-500">File name:</span> {{ asset_file_name }}
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="submit" class="btn btn-primary text-xs rounded-5">Update Asset</button>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="modal fade" id="bookingModal" tabindex="-1" aria-labelledby="bookingModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header bg-light">
        <h6 class="modal-title fw-bold" id="bookingModalLabel">Book Asset</h6>
        <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal"></button>
      </div>

      <form @submit.prevent="submit_booking">
        <div class="modal-body">
          <p><strong>Asset:</strong> {{ booking_asset.name }}</p>
          <div class="mb-3">
            <label class="form-label text-xs fw-500">Booking Date <span class="text-danger">*</span></label>
              <input
              type="date"
              class="form-control rounded-5 text-xs"
              v-model="booking_start_date"
              :min="new Date().toISOString().split('T')[0]"
              required
            />
            <div v-if="show_date_error" class="invalid-feedback d-block text-xs">
              Please select a date before choosing a time slot.
            </div>
          </div>

        <div class="mb-3">
          <label class="form-label text-xs fw-500">Select Time Slot<span class="text-danger">*</span></label>
                    <div class="time-slot-grid">
            <div
              v-for="(time, index) in generateFullTimeSlots()"
              :key="index"
              :class="get_slot_class(time)"
              @click="toggle_time_selection(time)"
            >
              {{ formatTime(time) }}
            </div>
          </div>
        </div>

          <div class="mb-3">
            <label class="form-label text-xs fw-500">Reason for Booking<span class="text-danger">*</span></label>
            <textarea
              class="form-control rounded-4 text-xs"
              rows="3"
              placeholder="Enter reason for booking..."
              v-model="booking_reason"
              required
            ></textarea>
          </div>

        </div>

        <div class="modal-footer">
          <button type="submit" class="btn btn-primary rounded-5" :disabled="bookingSubmitting || booking_ranges.length === 0">
            {{ bookingSubmitting ? 'Booking...' : 'Confirm Booking' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="modal fade" id="bookingsListModal" tabindex="-1" aria-labelledby="bookingsListModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-content">
      <!-- Header -->
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title fw-bold" id="bookingsListModalLabel">
          {{ selected_asset.name }} - Bookings
        </h5>
        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Body -->
      <div class="modal-body">
        <div v-if="booked_slots.length">
          <div class="table-responsive">
            <table class="table table-striped table-hover">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Booking Date</th>
                  <th>Start Time</th>
                  <th>End Time</th>
                  <th>Reason</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody class="text-sm">
                <tr v-for="booking in booked_slots" :key="booking.id">
                  <td class="fw-semibold">{{ booking.user.profile_name }}</td>
                  <td>{{ booking.booking_start_date }}</td>
                  <td><code class="text-dark">{{ formatTime(booking.booking_start_time) }}</code></td>
                  <td><code class="text-dark">{{ formatTime(booking.booking_end_time) }}</code></td>
                  <td>{{ booking.booking_reason || '—' }}</td>
                  <td>
                    <span v-if="(current_role !== 'admin' && selected_asset.creater?.id !== current_user_id) || booking.status.toLowerCase() !== 'pending'" class="badge"
                      :class="{
                        'bg-primary': booking.status.toLowerCase() === 'booked',
                        'bg-success': booking.status.toLowerCase() === 'completed',
                        'bg-warning': ['in progress'].includes(booking.status.toLowerCase()),
                        'bg-danger': ['cancelled', 'rejected'].includes(booking.status.toLowerCase()),
                      }">
                      {{ booking.status }}
                    </span>
                    <div
                    v-if="(current_role === 'admin' || selected_asset.creater?.id === current_user_id) && booking.status.toLowerCase() === 'pending'"
                    class="mt-2 d-flex gap-1"
                  >
                    <span @click="approve_booking(booking.id)"
                      class="badge bg-success text-white text-decoration-none pointer"
                    >
                      Approve
                    </span>
                    <span @click="reject_booking(booking.id)"
                      class="badge bg-danger text-white text-decoration-none pointer"
                    >
                      Reject
                    </span>
                  </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-else class="text-center text-muted py-5">
          <h6>No bookings found for this asset.</h6>
        </div>
      </div>

      <!-- Footer -->
      <div class="modal-footer bg-light">
        <small class="text-muted me-auto">
          Total: {{ booked_slots.length }} booking(s)
        </small>
        <button 
          @click="export_bookings_CSV" 
          class="btn btn-primary">
          Export CSV
        </button>
      </div>
      
    </div>
  </div>
</div>